import { ApolloCache, Reference } from "@apollo/client"
import { TRANSPORTERZONE_FRAGMENT } from "../fragment/transporterZone"

export const updateCacheTransporterZone = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      transporterZones(existing = []) {
        const newTransporterZoneRef = cache.writeFragment({
          data: entryData,
          fragment: TRANSPORTERZONE_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newTransporterZoneRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newTransporterZoneRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newTransporterZoneRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newTransporterZoneRef
            }
            return items
        }
      },
      aggregateTransporterZone(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
